/**
 * These types are not native yet, as some browsers to not support them.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Clipboard
 */
export type ClipboardPermissionResult = 'granted' | 'prompt' | 'denied' | 'unsupported';
export type ClipboardPermission = 'clipboard-write' | 'clipboard-read';

export const hasAdequatePermission = (permission: ClipboardPermissionResult): boolean =>
  permission == 'granted' || permission == 'prompt';
